module.exports = __webpack_public_path__ + "static/img/Logo_MarketPlace.03e7f38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Logo_MarketPlace.png
// module id = bb7A
// module chunks = 20